import { useState } from 'react';

import { CellClickedEvent } from 'ag-grid-community';

import { ContractSummary } from '@octopus/api';
import { SimulationSummary } from '@octopus/termination-api';

import { ContractSummaryWithFgtsBalance } from '../types';

export const useTerminationSimulationDrawer = (
  data: ContractSummary[] | SimulationSummary[],
) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState<number | null>(null);

  const handleCloseDrawer = () => {
    setSelectedRowIndex(null);
    setDrawerOpen(false);
  };

  const handleNext = () => {
    setSelectedRowIndex(selectedRowIndex + 1);
  };

  const handlePrevious = () => {
    setSelectedRowIndex(selectedRowIndex - 1);
  };

  const handleOpenDrawer = (
    event: CellClickedEvent<ContractSummaryWithFgtsBalance | SimulationSummary>,
  ) => {
    // ignore clicks on the selection checkbox (which has no field)
    if (!event.colDef.field) {
      event.node.setSelected(!event.node.isSelected());
      return;
    }
    setSelectedRowIndex(event.rowIndex);
    setDrawerOpen(true);
  };

  return {
    drawerOpen,
    handleCloseDrawer,
    handleOpenDrawer,
    selectedItem: data?.[selectedRowIndex],
    controls: {
      onDismiss: handleCloseDrawer,
      hasNext:
        selectedRowIndex !== null && selectedRowIndex !== data.length - 1,
      onNext: handleNext,
      onPrevious: handlePrevious,
      hasPrevious: selectedRowIndex !== null && selectedRowIndex !== 0,
    },
  };
};
